import { useLocation, useNavigate } from "react-router-dom";
import { scrollToId } from "@/hooks/useLenis";

export const NAV = [
  { label: "Collezione", to: "/collezione", id: "collezione" },
  { label: "La storia", hash: "storia", id: "storia" },
  { label: "Le proprietà", hash: "elicriso", id: "proprieta" },
  { label: "Il rituale", hash: "rituale", id: "rituale" },
  { label: "Contatti", to: "/contatti", id: "contatti" },
];

export const useNavGo = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return (item) => {
    if (item.to) navigate(item.to);
    else if (pathname === "/") scrollToId(item.hash);
    else navigate(`/#${item.hash}`);
  };
};
